import { useState } from 'react';

import { UserInfoType } from '../../type/UserInfoType';
import { permission } from '../../const/commonConst';

const initUserInfo = {
	isLogin: false,
	companyName: '',
	userName: '',
	permission: permission.id.unknown,
};

/**
 * ログインユーザ情報の状態管理用カスタムフック
 */
export const useStateUserInfo = () => {
	const [userInfo, setUserInfo] = useState<UserInfoType>(initUserInfo); // ログインユーザ情報の管理

	return {
		userInfo,
		setUserInfo,
	};
};
